import { useSuspenseQuery } from '@apollo/client/react';

import findOnePostQuery from '~/shared/graphql-queries/posts/find-one-post-query';

type FindOnePostQueryInput = {
  filter: {
    alias: string;
    language?: string | null;
  };
};

type UseFindOnePostQueryOptions = Parameters<typeof useSuspenseQuery>[1];

export const getFindOnePostQuery = ({ filter }: FindOnePostQueryInput) => ({
  query: findOnePostQuery,
  variables: {
    filter,
  },
});

export const useFindOnePostQuery = (filterOptions: FindOnePostQueryInput, options: UseFindOnePostQueryOptions = {}) => {
  const useQueryProps = useSuspenseQuery(findOnePostQuery, {
    variables: {
      filter: filterOptions.filter,
    },
    ...options,
  });

  const { refetch, error, data } = useQueryProps;

  return {
    loading: false,
    refetch,
    error,
    data,
  };
};
